import type { LitterListPageFormValues } from '@presentation/pages';

export const PAGINATED_SIZE = 32;

export const FORM_INITIAL_VALUES: LitterListPageFormValues = {
  // sortBy: LitterListSortType.DATE_DESC,
  price: [0, 5000],
  breedNames: [],
  sizeIds: [],
  pedigree: [],
  spokenLanguages: undefined,
  countries: undefined,
  regions: undefined,
};
